import React from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Stack,
  CardMedia,
  Button,
  Typography,
} from "@mui/material";
import useSlideShow from "../hooks/useSlideShow";
import { technologyIcons } from "../config";
import { ProjectDetailsDialogProps } from "../@types/types";

const ProjectDetailsDialog: React.FC<ProjectDetailsDialogProps> = ({
  open,
  handleClose,
  project,
}) => {
  const activeImageIndex = useSlideShow(project.imageUrl, 3000);
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      {project.imageUrl.map((src: any, index: any) => (
        <CardMedia
          key={index}
          component="img"
          height="320"
          width="420"
          image={src}
          alt={`${project.name} image ${index + 1}`}
          sx={{
            display: index === activeImageIndex ? "block" : "none",
            // width: "100%",
            borderRadius: "0px 0px 30px 30px",
            //height: "auto",
          }}
        />
      ))}
      <DialogTitle sx={{ fontWeight: "bold", fontSize: "25px" }}>
        {project.name}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{project.description}</DialogContentText>

        <Stack
          direction="row"
          spacing={1}
          sx={{ marginTop: 2, flexWrap: "wrap" }}
        >
          {project.technologies.map((tech) => (
            <img
              key={tech}
              src={technologyIcons[tech]}
              alt={tech}
              style={{ width: 24, height: 24, marginRight: 8 }}
            />
          ))}
        </Stack>

        <Typography variant="h6" sx={{ mt: 2 }}>
          {t("Features")}
        </Typography>
        <ul style={{ paddingLeft: 20 }}>
          {project.features?.map((feature: any, index: any) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectDetailsDialog;
